import React from 'react';

import { RecentYats } from '@app/pages/DiscoverPage/components/RecentYats/RecentYats';

import { Link, Links, Wrapper } from './Footer.style';

export function Footer() {
    return (
        <Wrapper>
            <RecentYats />

            <Links>
                <Link href="https://legal.y.at/privacy-policy" target="_blank" rel="noreferrer">
                    Privacy Policy
                </Link>
                <Link href="https://legal.y.at/terms" target="_blank" rel="noreferrer">
                    Terms of Service
                </Link>
                <Link href="https://legal.y.at/disclosure" target="_blank" rel="noreferrer">
                    Disclosure
                </Link>
                <Link href="https://emojis.y.at/support" target="_blank" rel="noreferrer">
                    Help
                </Link>
            </Links>
        </Wrapper>
    );
}
